export default "__VITE_ASSET__CZKgI895__"